/**
 * Countries — ISO 3166-1 alpha-2 code, common name, dial code, and a
 * SAMPLE phone format (used as a placeholder hint in the Export Order
 * modal — hint only, no validation).
 *
 * Sources: ITU-T E.164 dial code list + local formatting conventions.
 * Not exhaustive for every micro-nation but covers ~200 dial codes
 * relevant for GCC-based B2B export desks.
 */

const COUNTRIES = [
  { code: "AE", name: "United Arab Emirates", dial: "+971", sample: "+971 50 123 4567" },
  { code: "AF", name: "Afghanistan", dial: "+93", sample: "+93 70 123 4567" },
  { code: "AL", name: "Albania", dial: "+355", sample: "+355 66 123 4567" },
  { code: "AM", name: "Armenia", dial: "+374", sample: "+374 77 123456" },
  { code: "AO", name: "Angola", dial: "+244", sample: "+244 923 123 456" },
  { code: "AR", name: "Argentina", dial: "+54", sample: "+54 9 11 1234 5678" },
  { code: "AT", name: "Austria", dial: "+43", sample: "+43 664 123 4567" },
  { code: "AU", name: "Australia", dial: "+61", sample: "+61 412 345 678" },
  { code: "AZ", name: "Azerbaijan", dial: "+994", sample: "+994 50 123 45 67" },
  { code: "BA", name: "Bosnia and Herzegovina", dial: "+387", sample: "+387 61 123 456" },
  { code: "BD", name: "Bangladesh", dial: "+880", sample: "+880 1712 345678" },
  { code: "BE", name: "Belgium", dial: "+32", sample: "+32 470 12 34 56" },
  { code: "BG", name: "Bulgaria", dial: "+359", sample: "+359 87 123 4567" },
  { code: "BH", name: "Bahrain", dial: "+973", sample: "+973 3600 1234" },
  { code: "BJ", name: "Benin", dial: "+229", sample: "+229 90 01 23 45" },
  { code: "BN", name: "Brunei", dial: "+673", sample: "+673 712 3456" },
  { code: "BO", name: "Bolivia", dial: "+591", sample: "+591 712 34567" },
  { code: "BR", name: "Brazil", dial: "+55", sample: "+55 11 91234-5678" },
  { code: "BT", name: "Bhutan", dial: "+975", sample: "+975 17 12 34 56" },
  { code: "BW", name: "Botswana", dial: "+267", sample: "+267 71 123 456" },
  { code: "BY", name: "Belarus", dial: "+375", sample: "+375 29 123 45 67" },
  { code: "BZ", name: "Belize", dial: "+501", sample: "+501 622 1234" },
  { code: "CA", name: "Canada", dial: "+1", sample: "+1 416 555 0132" },
  { code: "CD", name: "DR Congo", dial: "+243", sample: "+243 81 234 5678" },
  { code: "CF", name: "Central African Rep.", dial: "+236", sample: "+236 70 01 23 45" },
  { code: "CG", name: "Congo", dial: "+242", sample: "+242 06 123 4567" },
  { code: "CH", name: "Switzerland", dial: "+41", sample: "+41 78 123 45 67" },
  { code: "CI", name: "Côte d'Ivoire", dial: "+225", sample: "+225 01 23 45 67 89" },
  { code: "CL", name: "Chile", dial: "+56", sample: "+56 2 2345 6789" },
  { code: "CM", name: "Cameroon", dial: "+237", sample: "+237 6 71 23 45 67" },
  { code: "CN", name: "China", dial: "+86", sample: "+86 138 0013 8000" },
  { code: "CO", name: "Colombia", dial: "+57", sample: "+57 321 1234567" },
  { code: "CR", name: "Costa Rica", dial: "+506", sample: "+506 8312 3456" },
  { code: "CU", name: "Cuba", dial: "+53", sample: "+53 5 1234567" },
  { code: "CY", name: "Cyprus", dial: "+357", sample: "+357 96 123456" },
  { code: "CZ", name: "Czech Republic", dial: "+420", sample: "+420 601 123 456" },
  { code: "DE", name: "Germany", dial: "+49", sample: "+49 151 23456789" },
  { code: "DJ", name: "Djibouti", dial: "+253", sample: "+253 77 83 10 01" },
  { code: "DK", name: "Denmark", dial: "+45", sample: "+45 32 12 34 56" },
  { code: "DO", name: "Dominican Republic", dial: "+1", sample: "+1 809 234 5678" },
  { code: "DZ", name: "Algeria", dial: "+213", sample: "+213 551 23 45 67" },
  { code: "EC", name: "Ecuador", dial: "+593", sample: "+593 99 123 4567" },
  { code: "EE", name: "Estonia", dial: "+372", sample: "+372 5123 4567" },
  { code: "EG", name: "Egypt", dial: "+20", sample: "+20 100 123 4567" },
  { code: "ER", name: "Eritrea", dial: "+291", sample: "+291 7 123 456" },
  { code: "ES", name: "Spain", dial: "+34", sample: "+34 612 34 56 78" },
  { code: "ET", name: "Ethiopia", dial: "+251", sample: "+251 91 123 4567" },
  { code: "FI", name: "Finland", dial: "+358", sample: "+358 41 234 5678" },
  { code: "FJ", name: "Fiji", dial: "+679", sample: "+679 701 2345" },
  { code: "FR", name: "France", dial: "+33", sample: "+33 6 12 34 56 78" },
  { code: "GA", name: "Gabon", dial: "+241", sample: "+241 06 03 12 34" },
  { code: "GB", name: "United Kingdom", dial: "+44", sample: "+44 7400 123456" },
  { code: "GE", name: "Georgia", dial: "+995", sample: "+995 555 12 34 56" },
  { code: "GH", name: "Ghana", dial: "+233", sample: "+233 23 123 4567" },
  { code: "GN", name: "Guinea", dial: "+224", sample: "+224 601 12 34 56" },
  { code: "GR", name: "Greece", dial: "+30", sample: "+30 691 234 5678" },
  { code: "GT", name: "Guatemala", dial: "+502", sample: "+502 5123 4567" },
  { code: "HK", name: "Hong Kong", dial: "+852", sample: "+852 5123 4567" },
  { code: "HN", name: "Honduras", dial: "+504", sample: "+504 9123 4567" },
  { code: "HR", name: "Croatia", dial: "+385", sample: "+385 91 234 5678" },
  { code: "HT", name: "Haiti", dial: "+509", sample: "+509 34 12 3456" },
  { code: "HU", name: "Hungary", dial: "+36", sample: "+36 20 123 4567" },
  { code: "ID", name: "Indonesia", dial: "+62", sample: "+62 812 3456 7890" },
  { code: "IE", name: "Ireland", dial: "+353", sample: "+353 85 123 4567" },
  { code: "IL", name: "Israel", dial: "+972", sample: "+972 50 123 4567" },
  { code: "IN", name: "India", dial: "+91", sample: "+91 98765 43210" },
  { code: "IQ", name: "Iraq", dial: "+964", sample: "+964 791 123 4567" },
  { code: "IR", name: "Iran", dial: "+98", sample: "+98 912 345 6789" },
  { code: "IS", name: "Iceland", dial: "+354", sample: "+354 611 1234" },
  { code: "IT", name: "Italy", dial: "+39", sample: "+39 312 345 6789" },
  { code: "JM", name: "Jamaica", dial: "+1", sample: "+1 876 210 1234" },
  { code: "JO", name: "Jordan", dial: "+962", sample: "+962 79 123 4567" },
  { code: "JP", name: "Japan", dial: "+81", sample: "+81 90 1234 5678" },
  { code: "KE", name: "Kenya", dial: "+254", sample: "+254 712 345678" },
  { code: "KG", name: "Kyrgyzstan", dial: "+996", sample: "+996 700 123 456" },
  { code: "KH", name: "Cambodia", dial: "+855", sample: "+855 91 234 567" },
  { code: "KR", name: "South Korea", dial: "+82", sample: "+82 10 1234 5678" },
  { code: "KW", name: "Kuwait", dial: "+965", sample: "+965 500 12345" },
  { code: "KZ", name: "Kazakhstan", dial: "+7", sample: "+7 771 000 9998" },
  { code: "LA", name: "Laos", dial: "+856", sample: "+856 20 23 123 456" },
  { code: "LB", name: "Lebanon", dial: "+961", sample: "+961 71 123 456" },
  { code: "LK", name: "Sri Lanka", dial: "+94", sample: "+94 71 234 5678" },
  { code: "LR", name: "Liberia", dial: "+231", sample: "+231 77 012 3456" },
  { code: "LT", name: "Lithuania", dial: "+370", sample: "+370 612 34567" },
  { code: "LU", name: "Luxembourg", dial: "+352", sample: "+352 628 123 456" },
  { code: "LV", name: "Latvia", dial: "+371", sample: "+371 21 234 567" },
  { code: "LY", name: "Libya", dial: "+218", sample: "+218 91 234 5678" },
  { code: "MA", name: "Morocco", dial: "+212", sample: "+212 650 123456" },
  { code: "MD", name: "Moldova", dial: "+373", sample: "+373 621 12 345" },
  { code: "MG", name: "Madagascar", dial: "+261", sample: "+261 32 12 345 67" },
  { code: "ML", name: "Mali", dial: "+223", sample: "+223 65 01 23 45" },
  { code: "MM", name: "Myanmar", dial: "+95", sample: "+95 9 123 456 789" },
  { code: "MN", name: "Mongolia", dial: "+976", sample: "+976 88 12 3456" },
  { code: "MO", name: "Macau", dial: "+853", sample: "+853 6612 3456" },
  { code: "MT", name: "Malta", dial: "+356", sample: "+356 9696 1234" },
  { code: "MU", name: "Mauritius", dial: "+230", sample: "+230 5 251 2345" },
  { code: "MV", name: "Maldives", dial: "+960", sample: "+960 771 2345" },
  { code: "MW", name: "Malawi", dial: "+265", sample: "+265 991 234 567" },
  { code: "MX", name: "Mexico", dial: "+52", sample: "+52 55 1234 5678" },
  { code: "MY", name: "Malaysia", dial: "+60", sample: "+60 12 345 6789" },
  { code: "MZ", name: "Mozambique", dial: "+258", sample: "+258 82 123 4567" },
  { code: "NA", name: "Namibia", dial: "+264", sample: "+264 81 123 4567" },
  { code: "NE", name: "Niger", dial: "+227", sample: "+227 93 12 34 56" },
  { code: "NG", name: "Nigeria", dial: "+234", sample: "+234 802 123 4567" },
  { code: "NI", name: "Nicaragua", dial: "+505", sample: "+505 8123 4567" },
  { code: "NL", name: "Netherlands", dial: "+31", sample: "+31 6 12345678" },
  { code: "NO", name: "Norway", dial: "+47", sample: "+47 406 12 345" },
  { code: "NP", name: "Nepal", dial: "+977", sample: "+977 984 1234567" },
  { code: "NZ", name: "New Zealand", dial: "+64", sample: "+64 21 123 4567" },
  { code: "OM", name: "Oman", dial: "+968", sample: "+968 9123 4567" },
  { code: "PA", name: "Panama", dial: "+507", sample: "+507 6123 4567" },
  { code: "PE", name: "Peru", dial: "+51", sample: "+51 912 345 678" },
  { code: "PG", name: "Papua New Guinea", dial: "+675", sample: "+675 7012 3456" },
  { code: "PH", name: "Philippines", dial: "+63", sample: "+63 917 123 4567" },
  { code: "PK", name: "Pakistan", dial: "+92", sample: "+92 300 1234567" },
  { code: "PL", name: "Poland", dial: "+48", sample: "+48 512 345 678" },
  { code: "PT", name: "Portugal", dial: "+351", sample: "+351 912 345 678" },
  { code: "PY", name: "Paraguay", dial: "+595", sample: "+595 961 456789" },
  { code: "QA", name: "Qatar", dial: "+974", sample: "+974 3312 3456" },
  { code: "RO", name: "Romania", dial: "+40", sample: "+40 712 345 678" },
  { code: "RS", name: "Serbia", dial: "+381", sample: "+381 60 123 4567" },
  { code: "RU", name: "Russia", dial: "+7", sample: "+7 912 345 67 89" },
  { code: "RW", name: "Rwanda", dial: "+250", sample: "+250 720 123 456" },
  { code: "SA", name: "Saudi Arabia", dial: "+966", sample: "+966 51 234 5678" },
  { code: "SD", name: "Sudan", dial: "+249", sample: "+249 91 123 4567" },
  { code: "SE", name: "Sweden", dial: "+46", sample: "+46 70 123 45 67" },
  { code: "SG", name: "Singapore", dial: "+65", sample: "+65 8123 4567" },
  { code: "SI", name: "Slovenia", dial: "+386", sample: "+386 31 234 567" },
  { code: "SK", name: "Slovakia", dial: "+421", sample: "+421 912 123 456" },
  { code: "SL", name: "Sierra Leone", dial: "+232", sample: "+232 25 123456" },
  { code: "SN", name: "Senegal", dial: "+221", sample: "+221 70 123 45 67" },
  { code: "SO", name: "Somalia", dial: "+252", sample: "+252 61 234 5678" },
  { code: "SR", name: "Suriname", dial: "+597", sample: "+597 741 2345" },
  { code: "SS", name: "South Sudan", dial: "+211", sample: "+211 977 123 456" },
  { code: "SY", name: "Syria", dial: "+963", sample: "+963 944 567 890" },
  { code: "TD", name: "Chad", dial: "+235", sample: "+235 63 01 23 45" },
  { code: "TG", name: "Togo", dial: "+228", sample: "+228 90 11 23 45" },
  { code: "TH", name: "Thailand", dial: "+66", sample: "+66 81 234 5678" },
  { code: "TJ", name: "Tajikistan", dial: "+992", sample: "+992 917 12 3456" },
  { code: "TM", name: "Turkmenistan", dial: "+993", sample: "+993 66 123456" },
  { code: "TN", name: "Tunisia", dial: "+216", sample: "+216 20 123 456" },
  { code: "TR", name: "Turkey", dial: "+90", sample: "+90 501 234 5678" },
  { code: "TT", name: "Trinidad and Tobago", dial: "+1", sample: "+1 868 291 1234" },
  { code: "TW", name: "Taiwan", dial: "+886", sample: "+886 912 345 678" },
  { code: "TZ", name: "Tanzania", dial: "+255", sample: "+255 621 234 567" },
  { code: "UA", name: "Ukraine", dial: "+380", sample: "+380 50 123 4567" },
  { code: "UG", name: "Uganda", dial: "+256", sample: "+256 712 345 678" },
  { code: "US", name: "United States", dial: "+1", sample: "+1 415 555 2671" },
  { code: "UY", name: "Uruguay", dial: "+598", sample: "+598 94 231 234" },
  { code: "UZ", name: "Uzbekistan", dial: "+998", sample: "+998 91 123 45 67" },
  { code: "VE", name: "Venezuela", dial: "+58", sample: "+58 412 1234567" },
  { code: "VN", name: "Vietnam", dial: "+84", sample: "+84 91 234 56 78" },
  { code: "YE", name: "Yemen", dial: "+967", sample: "+967 712 345 678" },
  { code: "ZA", name: "South Africa", dial: "+27", sample: "+27 71 123 4567" },
  { code: "ZM", name: "Zambia", dial: "+260", sample: "+260 95 1234567" },
  { code: "ZW", name: "Zimbabwe", dial: "+263", sample: "+263 71 234 5678" },
];

// Sort alphabetically by name for the dropdown.
export const EXPORT_COUNTRIES = [...COUNTRIES].sort((a, b) => a.name.localeCompare(b.name));

export const findCountryByCode = (code) => COUNTRIES.find((c) => c.code === code) || null;

export default EXPORT_COUNTRIES;
